import { PropsWithChildren } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Drawer, DrawerContent, DrawerClose } from "../ui/drawer";
import MobileDesktop from "../MobileDesktop/MobileDesktop";
import { cn } from "@/lib/utils";
import { XCircle } from "lucide-react";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";

interface Props extends PropsWithChildren {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  size?: "sm" | "md" | "lg";
  className?: string;
  repositionInputs?: boolean;
}

export function ResponsiveModal({
  open,
  onOpenChange,
  title,
  children,
  size = "md",
  className,
  repositionInputs = true,
}: Props) {
  return (
    <MobileDesktop
      mobile={
        <Drawer
          open={open}
          onOpenChange={onOpenChange}
          repositionInputs={repositionInputs}
          modal
        >
          <DrawerContent
            className={className}
            style={{
              maxHeight: "90vh",
            }}
          >
            <VisuallyHidden>
              <DialogTitle>{title}</DialogTitle>
            </VisuallyHidden>
            <div className="flex w-full justify-end px-4">
              <DrawerClose>
                <XCircle className="w-4 h-4 text-gray-500" />
              </DrawerClose>
            </div>
            <div className="container py-4 overflow-y-auto">
              <div>{children}</div>
            </div>
          </DrawerContent>
        </Drawer>
      }
      desktop={
        <Dialog open={open} onOpenChange={onOpenChange}>
          <DialogContent
            className={cn("w-full max-h-[90vh] overflow-y-auto", className, {
              "max-w-md": size === "md",
              "max-w-sm": size === "sm",
              "max-w-4xl": size === "lg",
            })}
          >
            {title && (
              <DialogHeader>
                <DialogTitle>{title}</DialogTitle>
              </DialogHeader>
            )}
            {children}
          </DialogContent>
        </Dialog>
      }
    />
  );
}
